import { render, staticRenderFns } from "./CartaoObservacoesGerais.vue?vue&type=template&id=cc240060&scoped=true"
import script from "./CartaoObservacoesGerais.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoObservacoesGerais.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoObservacoesGerais.vue?vue&type=style&index=0&id=cc240060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc240060",
  null
  
)

export default component.exports